import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import classNames from "classnames";
import { forwardRef } from "react";
import { dropdownMenuItem } from "./DropdownMenuItem";
export const dropdownMenuRadioItem = tailwindVariants({
    extend: dropdownMenuItem,
    base: "justify-between"
});
export const DropdownMenuRadioItem = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, description, label, prefix, size, ...restOfProps } = param;
    const hasDescription = !!description;
    const isSmall = size === "small";
    return /*#__PURE__*/ _jsxs(RadixDropdownMenu.RadioItem, {
        className: dropdownMenuRadioItem({
            size,
            className
        }),
        ...restOfProps,
        ref: forwardedRef,
        children: [
            !!children ? children : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !!prefix ? /*#__PURE__*/ _jsx("div", {
                        className: classNames("mr-2 shrink-0", hasDescription ? isSmall ? "mt-0.5" : "mt-1" : "mt-0"),
                        children: prefix
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex min-w-0 grow flex-col",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: classNames("truncate", isSmall ? "text-14" : "text-16"),
                                children: label
                            }),
                            hasDescription ? /*#__PURE__*/ _jsx("span", {
                                className: classNames("text-grey-8", isSmall ? "text-12" : "text-14"),
                                children: description
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(RadixDropdownMenu.ItemIndicator, {
                className: classNames("ml-2 shrink-0", hasDescription ? isSmall ? "mt-0.5" : "mt-1" : "mt-0"),
                children: /*#__PURE__*/ _jsx(Check, {
                    className: "size-4"
                })
            })
        ]
    });
});
DropdownMenuRadioItem.displayName = "DropdownMenuRadioItem";
